import Vue from 'vue'
import { drag } from '@thinkacademy/vitas-utils'

Vue.directive('drag', drag)
